import React, { useContext, useEffect } from "react";
import { useNavigateWithSameKey } from "../../../../../../../../../../../custom-hooks/navigateWithKey";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  LoadingModalContext,
  MessagePopupContext,
} from "../../../../../../../../../ServicePage";
import { setFeatureFiles } from "../../../../../../../../../../../store/slices/test-automation/web/flow-stages/playwrightCSharpSpecflowSlices";
import FeatureFile from "../../../../../shared/FeatureFile";
import { Box, Button, Card, CardContent, Container, Typography } from "@mui/material";
import {
  ArrowBack as BackIcon,
  ArrowForward as NextIcon,
} from "@mui/icons-material";

const FeatureFilePagePlaywrightCSharpSpecflow = () => {
  const location = useLocation();
  const navigate = useNavigateWithSameKey();
  const dispatch = useDispatch();

  const { locationKey } = location.state;

  const { featureFiles, automationPath } = useSelector(
    (state) =>
      state["testAutomation"][locationKey]["webAutomation"][
        "playwrightCSharpSpecflow"
      ] || {}
  );

  const { setLoadingState } = useContext(LoadingModalContext);
  const { setMessage, setMessagePopup } = useContext(MessagePopupContext);

  useEffect(() => {
    if (!locationKey) {
      navigate("/landingpage");
      return;
    }
  }, [locationKey]);

  const handleBackClick = () => {
    // Navigate to the previous step (Test Case Imported)
    navigate(-1);
  };

  const handleContinueClick = () => {
    try {
      navigate(`${automationPath}/page-dom`);
    } catch (error) {
      setMessage("Couldn't process your request please try again");
      setMessagePopup(true);
    }
  };

  const handleSaveContent = (content) => {
    dispatch(setFeatureFiles(locationKey, content));
  };

  return (
    <Box sx={{ height: "100%" }}>
      {/* You can now display the feature file content */}
      {featureFiles ? (
        <FeatureFile
          title="Feature File"
          content={featureFiles}
          handleSaveContent={handleSaveContent}
        />
      ) : (
        <Box
          sx={{
            height: "100%",
            background: "#F6F3F2",
            display: "flex",
            flexDirection: "column",
            py: 4,
          }}
        >
          <Container sx={{ width: "100%", flex: 1 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                mb: 4,
                fontWeight: "bold",
                color: "#333",
                fontSize: "28px",
                fontFamily: "Manrope",
              }}
            >
              Feature File
            </Typography>
            <Card
              sx={{
                backgroundColor: "white",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                mb: 4,
                maxWidth: "100%",
              }}
            >
              <CardContent sx={{ p: 4, textAlign: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ color: "#666", fontFamily: "Manrope", mb: 2 }}
                >
                  No data available. Please go back and generate feature files
                  first.
                </Typography>
              </CardContent>
            </Card>
          </Container>
        </Box>
      )}

      <Box
        sx={{
          p: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "transparent",
          borderRadius: "0 0 8px 8px",
        }}
      >
        {/* Back Button */}
        <Button
          variant="outlined"
          startIcon={<BackIcon />}
          onClick={handleBackClick}
          sx={{
            borderColor: "#0094FB",
            color: "#0094FB",
            textTransform: "none",
            // fontFamily: "Manrope",
            fontWeight: 500,
            borderRadius: "8px",
            borderWidth: "2px",
            paddingTop: "8px",
            paddingRight: "16px",
            paddingBottom: "8px",
            paddingLeft: "16px",
            gap: "8px",
            "&:hover": {
              borderColor: "#0094FB",
              backgroundColor: "rgba(0, 148, 251, 0.04)",
            },
          }}
        >
          Back
        </Button>

        {/* Continue Button */}
        <Button
          variant="contained"
          endIcon={<NextIcon />}
          onClick={handleContinueClick}
          disabled={!featureFiles}
          sx={{
            backgroundColor: "#0094FB",
            color: "white",
            textTransform: "none",
            // fontFamily: "Manrope",
            fontWeight: 500,
            borderRadius: "8px",
            borderWidth: "2px",
            borderColor: "#0094FB",
            paddingTop: "8px",
            paddingRight: "16px",
            paddingBottom: "8px",
            paddingLeft: "16px",
            "&:hover": {
              backgroundColor: "#0078D4",
              borderColor: "#0078D4",
            },
          }}
        >
          Introduce SUT
        </Button>
      </Box>
    </Box>
  );
};

export default FeatureFilePagePlaywrightCSharpSpecflow;
